import React, { useState, useEffect, useRef } from 'react';
import { Tabs, Menu, Dropdown, Popover, Button } from 'antd';
import message from '@web-common/components/UI/Message/SiriusMessage';
import classnames from 'classnames';
import PlusOutlined from '@ant-design/icons/PlusOutlined';
import MoreOutlined from '@ant-design/icons/MoreOutlined';
import LoadingOutlined from '@ant-design/icons/LoadingOutlined';
import { apiHolder as api, apis, ProductTagEnum, } from 'api';
import { useActions, useAppSelector, MailTemplateActions } from '@web-common/state/createStore';
import Popconfirm from './popconfirm';
import Preview from './preview';
import './listmodal.scss';
import previewStyle from './preview.module.scss';
import NoWifi from '@/images/no-wifi.png';
import NoDoc from '@/images/empty/doc.png';
import { formatViewMail } from './util';
import { ReactComponent as DeleteIcon } from '@/images/icons/modal_close_temp.svg';
import Modal from '@web-common/components/UI/Modal/SiriusModal';
import ProductAuthTag from '@web-common/components/UI/ProductAuthTag/ProductAuthTag';
import { getIn18Text } from 'api';
const templateApi = api.api.requireLogicalApi(apis.mailTemplateImplApi);
const mailApi = api.api.requireLogicalApi(apis.mailApiImpl);
const systemApi = api.api.getSystemApi();
const storeApi = api.api.getDataStoreApi();
const accountApi = api.api.requireLogicalApi(apis.accountApiImpl);
const { TabPane } = Tabs;
export const TemplateListModal = (props) => {
    const { emitResult, templateCategory = 'LX', operateMail = '', isSetting } = props;
    const showTemplateList = useAppSelector(state => state.mailTemplateReducer.showTemplateList);
    const defaultActiveTab = useAppSelector(state => state.mailTemplateReducer.defaultActiveTab);
    const { changeShowTemplateList, changeShowAddTemplatePop, doWriteTemplate, doModifyTemplateName } = useActions(MailTemplateActions);
    const curAccount = useAppSelector(state => { var _a; return (_a = state.mailReducer.currentMail) === null || _a === void 0 ? void 0 : _a.optSender; });
    const [templates, setTemplates] = useState([]);
    const [tabActiveKey, setTabActiveKey] = useState(3);
    const [apiSuccess, setApiSuccess] = useState(true);
    const [isLoading, setIsLoading] = useState(true);
    const [tooltipOpen, setTooltipOpen] = useState(false);
    const notFirstTaskMail = storeApi.getSync('notFirstAccount').data;
    const inElectron = systemApi.isElectron();
    const modalRef = useRef(null);
    const timeLimitedTmp = [
        { templateId: '118376158952722521', templateName: getIn18Text('RIBAO/ZHOUBAO') },
        { templateId: '118376486322339889', templateName: getIn18Text('GONGZUOJINDUHUI') },
        { templateId: '118737047174283357', templateName: getIn18Text('HUIYIJIYAO\uFF08') },
        { templateId: '125706462616911918', templateName: getIn18Text('XIANGMUGUIHUA') },
        { templateId: '125706745904398355', templateName: getIn18Text('HUODONGCEHUAFANG') },
        { templateId: '125707310466109463', templateName: getIn18Text('SWOTFEN') },
        { templateId: '125707542893461556', templateName: getIn18Text('SHEJIXUQIU') },
        { templateId: '125708100782035009', templateName: getIn18Text('FEIYONGSHENPI') },
        { templateId: '125708348568932425', templateName: getIn18Text('GONGZUOJIAOJIE') },
        { templateId: '125708606527012904', templateName: getIn18Text('GONGZIBIAO') },
        { templateId: '125708807736168472', templateName: getIn18Text('BAOXIAODAN') },
        { templateId: '125709628926361609', templateName: getIn18Text('HEZUOYIXIANGSHU') },
    ];
    useEffect(() => {
        accountApi.doGetAllAccountList().then(res => {
            const account = res[0];
            if (account.length > 1 && !notFirstTaskMail) {
                setTooltipOpen(true);
                storeApi.put('notFirstAccount', 'true');
            }
        });
    }, []);
    const getTemplates = async () => {
        setIsLoading(true);
        setApiSuccess(true);
        setTabActiveKey(defaultActiveTab);
        const _account = isSetting ? operateMail : curAccount ? curAccount.mailEmail : '';
        await templateApi
            .doGetMailTemplateList({ templateCategory, supportNewTemplateType: 'ENTERPRISE' }, _account)
            .then(res => {
            res.data || (res.data = []);
            setTemplates(res.data);
            setApiSuccess(res.success);
            setIsLoading(false);
            if (defaultActiveTab) {
                for (let i = 0; i < res.data.length; i++) {
                    if (res.data[i].tabId === defaultActiveTab) {
                        setTabActiveKey(res.data[i].tabId);
                        return;
                    }
                }
            }
            for (let i = 0; i < res.data.length; i++) {
                if (res.data[i].templateList.length > 0) {
                    setTabActiveKey(res.data[i].tabId);
                    return;
                }
            }
            setTabActiveKey(1);
        })
            .catch(e => {
            setIsLoading(false);
            setTemplates([]);
            setApiSuccess(false);
        });
    };
    useEffect(() => {
        if (showTemplateList) {
            getTemplates();
        }
    }, [showTemplateList]);
    const newTemplate = () => {
        changeShowTemplateList({ isShow: false });
        changeShowAddTemplatePop({ isShow: true, source: 'list' });
    };
    const operations = (React.createElement("p", { className: "add-temp-btn", onClick: newTemplate },
        React.createElement(PlusOutlined, { style: { marginRight: '6px' } }),
        getIn18Text('XINJIANGERENMO')));
    const TabItem = (itemProps) => {
        const { templateData } = itemProps;
        const [showBtn, setShowBtn] = useState(false);
        const [showDeletePop, setShowDeletePop] = useState(false);
        const handleDelete = () => {
            setShowDeletePop(false);
            const _account = isSetting ? operateMail : curAccount ? curAccount.mailEmail : '';
            templateApi.doDeleteMailTemplate({ templateId: templateData.templateId }, _account).then(res => {
                if (res.data === 'success') {
                    message.success({
                        content: getIn18Text('SHANCHUCHENGGONG'),
                    });
                    const tabId = tabActiveKey;
                    getTemplates().then(() => {
                        setTabActiveKey(tabId);
                    });
                }
                else {
                    message.error({
                        content: getIn18Text('SHANCHUSHIBAI'),
                    });
                }
            });
        };
        const editTemplate = () => {
            const _account = isSetting ? operateMail : curAccount ? curAccount.mailEmail : '';
            templateApi.doGetMailTemplateDetail({ templateId: templateData.templateId }, _account).then(async (res) => {
                if (res.success && res.data) {
                    const viewMail = await formatViewMail(res.data);
                    changeShowTemplateList({ isShow: false });
                    changeShowAddTemplatePop({ isShow: true, source: 'list' });
                    doWriteTemplate(viewMail);
                    doModifyTemplateName(res.data.templateName);
                }
            });
        };
        const useMailTemplate = () => {
            const _account = isSetting ? operateMail : curAccount ? curAccount.mailEmail : '';
            templateApi.doSaveMailTemplateUseTime({ templateId: templateData.templateId, time: new Date().getTime() }, _account);
            templateApi.doGetMailTemplateDetail({ templateId: templateData.templateId }, _account).then(async (res) => {
                if (res.success && res.data) {
                    const viewMail = await formatViewMail(res.data);
                    viewMail.form = 'template';
                    if (emitResult) {
                        emitResult(viewMail);
                    }
                    else {
                        const params = {
                            contact: [],
                            writeType: 'common',
                            mailType: 'common',
                            result: viewMail,
                        };
                        inElectron || changeShowTemplateList({ isShow: false });
                        mailApi.callWriteLetterFunc(params);
                    }
                }
            });
        };
        const menu = (React.createElement(Menu, null,
            React.createElement(Menu.Item, { onClick: editTemplate }, getIn18Text('BIANJI')),
            React.createElement(Menu.Item, null,
                React.createElement(Popover, { placement: "right", content: React.createElement(Popconfirm, { setShowDeletePop: setShowDeletePop, handleDelete: handleDelete }), trigger: "click", visible: showDeletePop, onVisibleChange: visible => {
                        setShowDeletePop(visible);
                    } }, getIn18Text('SHANCHU')))));
        return (React.createElement("div", { className: "tab-item", onMouseEnter: () => {
                setShowBtn(true);
            }, onMouseLeave: () => {
                setShowBtn(false);
            } },
            timeLimitedTmp.some(item => item.templateId === templateData.templateId) ? (React.createElement(ProductAuthTag, { tagName: ProductTagEnum.EMAIL_TEMPLATE, flowTipStyle: { left: '87px', top: '-7px', borderRadius: '0px 8px 0px 8px' } },
                React.createElement("div", { className: "tab-body-content", style: { backgroundImage: `url(${templateData.thumbnail.url})` } }))) : (React.createElement("div", { className: "tab-body-content", style: { backgroundImage: `url(${templateData.thumbnail.url})` } })),
            React.createElement("div", { className: "tab-body-btn", hidden: showBtn },
                React.createElement("p", { className: "tab-body-title" }, templateData.templateName)),
            React.createElement("div", { className: "tab-body-btn", hidden: !showBtn },
                React.createElement(Dropdown, { overlay: menu, placement: "topLeft" },
                    React.createElement("p", { className: "tab-body-btn-grey", hidden: templateData.templateType !== 'PERSONAL' },
                        React.createElement(MoreOutlined, { twoToneColor: "#FFFFFF", rotate: 90 }))),
                React.createElement(Popover, { placement: "right", content: React.createElement(Preview, { templateId: templateData.templateId }), trigger: "click" },
                    React.createElement("p", { className: "tab-body-btn-grey" }, getIn18Text('YULAN'))),
                React.createElement("p", { className: "tab-body-btn-primary", onClick: useMailTemplate }, getIn18Text('SHIYONG')))));
    };
    const TabBody = (tabBodyprops) => {
        var _a;
        const { onTabTemplate } = tabBodyprops;
        const haveList = (onTabTemplate === null || onTabTemplate === void 0 ? void 0 : onTabTemplate.templateList.length) > 0;
        return (React.createElement("div", { className: "tab-body-box" },
            React.createElement("p", { className: "tab-body-topDesc", hidden: onTabTemplate.tabId !== 4 },
                getIn18Text('QIYEMOBANYOU'),
                React.createElement("a", { href: "https://mailhz.qiye.163.com", target: "_blank", rel: "noreferrer" }, "https://mailhz.qiye.163.com"),
                getIn18Text('QIYEWENHUA')),
            React.createElement("div", { className: "tab-body" }, haveList ? (React.createElement(React.Fragment, null, (_a = onTabTemplate === null || onTabTemplate === void 0 ? void 0 : onTabTemplate.templateList) === null || _a === void 0 ? void 0 :
                _a.map(_ => (React.createElement(TabItem, { key: _.templateId, templateData: _ }))),
                React.createElement("p", { className: "tab-body-tailDesc" }, onTabTemplate === null || onTabTemplate === void 0 ? void 0 : onTabTemplate.tailDesc))) : (React.createElement("div", { className: "tab-nodoc" },
                React.createElement("img", { style: { width: 160, height: 160, margin: '60px auto 0' }, src: NoDoc, alt: "noDoc" }),
                React.createElement("p", { hidden: onTabTemplate.tabId !== 1, className: "nodoc-txt" },
                    getIn18Text('ZUIJIN6GEYUE'),
                    React.createElement("span", { className: "add-temp-btn", onClick: newTemplate }, getIn18Text('XINJIANGERENMO')),
                    getIn18Text('SHISHIBA\uFF5E')),
                React.createElement("p", { hidden: onTabTemplate.tabId !== 2, className: "nodoc-txt" },
                    getIn18Text('NIHAIMEIYOUZI'),
                    React.createElement("span", { className: "add-temp-btn", onClick: newTemplate }, getIn18Text('XINJIANGERENMO')),
                    getIn18Text('SHISHIBA\uFF5E')),
                React.createElement("p", { hidden: onTabTemplate.tabId !== 4, className: "nodoc-txt" }, getIn18Text('ZANWUQIYEMO')))))));
    };
    const tabTag = (tab) => {
        if (tab.tabId === 3) {
            return React.createElement(ProductAuthTag, { tagName: ProductTagEnum.EMAIL_TEMPLATE }, tab.tab);
        }
        return tab.tab;
    };
    const closeTip = () => {
        setTooltipOpen(false);
    };
    const title = (React.createElement("div", { className: classnames(previewStyle.modalTitle) },
        getIn18Text('YOUJIANMOBAN'),
        React.createElement("div", { className: classnames(previewStyle.toolTip), hidden: !tooltipOpen },
            "\u7ED1\u5B9A\u591A\u4E2A\u8D26\u53F7\u540E\uFF0C\u4EC5\u5C55\u793A\u5C5E\u4E8E\u5F53\u524D\u8D26\u53F7\u4E0B\u7684\u6A21\u677F",
            React.createElement("span", { className: classnames(previewStyle.closeBtn), onClick: closeTip }, getIn18Text('ZHIDAOLE')))));
    return (React.createElement(Modal, { closeIcon: React.createElement(DeleteIcon, { className: "dark-invert" }), visible: showTemplateList, footer: null, title: title, width: "716px", className: "mail-template-list-modal", onCancel: () => changeShowTemplateList({ isShow: false }) },
        React.createElement(Tabs, { tabBarExtraContent: operations, activeKey: tabActiveKey.toString(), onChange: _tabActiveKey => {
                setTabActiveKey(parseInt(_tabActiveKey, 10));
            }, hidden: templates.length <= 0, onClick: e => e.stopPropagation() }, templates.map(_ => (React.createElement(TabPane, { tab: tabTag(_), key: _.tabId },
            React.createElement(TabBody, { onTabTemplate: _ }))))),
        React.createElement("div", { className: "loading-box extheme", hidden: apiSuccess },
            React.createElement("img", { style: { width: 160, height: 160, marginBottom: 8 }, src: NoWifi, alt: "noWifi" }),
            React.createElement("p", { style: { fontSize: 14, color: '#7D8085', marginBottom: 8 } }, getIn18Text('WANGLUBUKEYONG')),
            React.createElement(Button, { style: { width: 72, background: '#F4F4F5' }, onClick: getTemplates }, getIn18Text('SHUAXIN'))),
        React.createElement("div", { className: "loading-box extheme", hidden: !isLoading },
            React.createElement(LoadingOutlined, null))));
};
